<template>
    <div class="home-main-layout">
        <!--<keep-alive>-->
        <!--    <router-view v-if="$route.meta.keepAlive" />-->
        <!--</keep-alive>-->
        <!--<router-view v-if="!$route.meta.keepAlive" />-->
        <keep-alive :include="keepList">
            <router-view />
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: 'Layout',
    data() {
        return {
            keepList:['AdvertBook', 'AdvertPaper']
        }
    },
    created() {
    
    },
    mounted() {},
    components: {},
    methods: {},
}
</script>

<style scoped lang="scss">
.home-main-layout{
    width: 100%;
    height: 100%;
}
</style>
